import * as factory from '../../../iawp/src/js/factory'

if(!!document.querySelector('.wpcf7-form')) {
    factory.$(document.querySelector('.wpcf7-form')).find(factory.$(".form-inside")).each(function () {
    var $wrapper = factory.$(this);
    var $input = $wrapper.find("input,textarea,select");
    
    if ($input.val()) {
        console.log($input)
        $wrapper.addClass("is-filled");
    }

    $input
        .on("focusin", function () {
            console.log('iubiub')
        if (!$input.val()) {
            $wrapper.removeClass("is-filled");
        }

        $wrapper.addClass("is-focus");
        })
        .on("focusout", function () {
        if (!$input.val()) {
            $wrapper.removeClass("is-focus");
        } else {
            $wrapper.addClass("is-filled");
            $wrapper.removeClass("is-focus");
        } if ($input.val() == '') {
            $wrapper.removeClass("is-filled");
        }
        });
    });
}
